export default __webpack_public_path__ + "static/media/spice-capsule.e6d11c4d.gif";